module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"amazonWSCloudAccountsTable.accessKeyId":"Access Key Id","amazonWSCloudAccountsTable.bucketName":"Bucket Name","amazonWSCloudAccountsTable.expiry":"Expiry","amazonWSCloudAccountsTable.noData":"No amazon cloud connections configured.","amazonWSCloudAccountsTable.disconnectedUsageConnection":"Please update your usage connection with valid credentials"}}')
  delete Component.options._Ctor
}
